import styled from 'styled-components';

export const Wrapper = styled.div``;

export const NotAssigned = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${({theme}) => theme.colors.danger};
`;
